<template>
	<!-- footer -->
	<footer class="p-t-md" v-if="!hideOnIpadConfigurator">
		<div class="checkout-response hide">
			<iframe src="" />
		</div>
		<div class="container-fluid">
			<div class="footer-links p-a-0 p-b-md clearfix">
				<div class="foot-content">
					<h4 class="menu-title text-white text-upper text-light">NZXT Products</h4>
					<ul class="list-none">
						<li>
							<a href="https://www.nzxt.com/categories/cases">Cases</a>
						</li>
						<li>
							<a href="https://www.nzxt.com/categories/gaming-accessories">Gaming Accessories</a>
						</li>
						<li>
							<a href="https://www.nzxt.com/categories/cooling">Cooling</a>
						</li>
						<li>
							<a href="https://www.nzxt.com/categories/motherboards">Motherboards</a>
						</li>
						<li>
							<a href="https://www.nzxt.com/categories/power-supplies">Power</a>
						</li>
						<li>
							<a href="https://www.nzxt.com/categories/lighting">Lighting</a>
						</li>
						<li>
							<a href="https://www.nzxt.com/categories/case-accessories">Case Accessories</a>
						</li>
						<li>
							<a href="https://www.nzxt.com/product-overview/crft">CRFT</a>
						</li>
					</ul>
				</div>
				<div class="foot-content">
					<h4 class="menu-title text-white text-upper text-light">BLOG</h4>
					<ul class="list-none">
						<li>
							<a href="https://blog.nzxt.com/posts/">Posts</a>
						</li>
						<li>
							<a href="https://blog.nzxt.com/guides/">Guides</a>
						</li>
						<li>
							<a href="https://blog.nzxt.com/gallery/">Gallery</a>
						</li>
					</ul>
				</div>
				<div class="foot-content">
					<h4 class="menu-title text-white text-upper text-light">Contact us</h4>
					<ul class="list-none">
						<li>
							<a href="https://www.nzxt.com/customer-support" @click.prevent="trackSupportViews($event)">Contact Us</a>
						</li>
						<li>
							<a href="https://www.nzxt.com/customer-support" @click.prevent="trackSupportViews($event)">Customer Support</a>
						</li>
						<li>
							<a href="https://www.nzxt.com/about">Company</a>
						</li>
						<li>
							<a href="https://www.nzxt.com/founder">Founder Q&amp;A</a>
						</li>
						<li>
							<a href="https://www.nzxt.com/careers">Careers</a>
						</li>
						<li>
							<a href="https://www.nzxt.com/news">News</a>
						</li>
						<li>
							<a href="https://www.nzxt.com/am4-bracket">AM4 Bracket</a>
						</li>
					</ul>
				</div>
				<div class="foot-content">
					<h4 class="menu-title text-white text-upper text-light">NZXT Store</h4>
					<ul class="list-none">
						<li>
							<a href="https://www.nzxt.com/retailers">Find a retailer</a>
						</li>
						<li>
							<a href="https://www.nzxt.com/warranty">Warranty</a>
						</li>
						<li>
							<a href="https://www.nzxt.com/shipping-and-deliveries">NZXT Product Shipping Policy</a>
						</li>
						<li>
							<a href="https://www.nzxt.com/returns-and-exchanges">Returns &amp; Exchanges</a>
						</li>
					</ul>
					<h4 class="menu-title text-white text-upper text-light m-t-md">Misc</h4>
					<ul class="list-none">
						<li>
							<a href="https://www.nzxt.com/users/login">Log In</a>
						</li>
						<li>
							<a href="https://www.nzxt.com/users/signup">Sign Up</a>
						</li>
					</ul>
				</div>
				<div class="foot-content" id="foot-cam">
					<h4 class="menu-title text-white text-upper text-light">PC Monitoring</h4>
					<ul class="list-none">
						<li>
							<a href="https://www.nzxt.com/camapp">CAM</a>
						</li>
						<li>
							<a href="https://support.nzxt.com/hc/en-us/requests/new">Submit a request</a>
						</li>
						<li>
							<a href="https://www.nzxt.com/products">CAM Powered Products</a>
						</li>
						<li>
							<a href="https://www.nzxt.com/camapp">Download</a>
						</li>
					</ul>
				</div>
				<div class="foot-content" id="foot-bld">
					<h4 class="menu-title text-white text-upper text-light">NZXT BLD</h4>
					<ul class="list-none">
						<li>
							<router-link to="/what-is-bld">What is BLD</router-link>
						</li>
						<li>
							<router-link to="/reviews">Customer Reviews</router-link>
						</li>
						<li>
							<router-link to="/warranty">Warranty</router-link>
						</li>
						<li>
							<router-link to="/shipping-and-deliveries">BLD Shipping Policy</router-link>
						</li>
						<li>
							<router-link to="/returns-and-exchanges">Returns &amp; Exchanges</router-link>
						</li>
						<li>
							<a href="https://support.nzxt.com/hc/en-us/requests/new" target="_blank">Submit a request</a>
						</li>
						<li>
							<a href="https://support.nzxt.com/hc/en-us/categories/360001823193-Gaming-PCS" target="_blank">FAQ</a>
						</li>
						<li>
							<a href="/learn" target="_blank">Learn</a>
						</li>
						<li>
							<a href="https://www.nzxt.com/customer-support" target="_blank">Customer Support</a>
						</li>
						<li>
							<router-link to="/refurbished-builds">Refurbished Builds</router-link>
						</li>
						<li>
							<router-link to="/bulk-purchase">Bulk Purchase</router-link>
						</li>
					</ul>
				</div>
				<div class="foot-content" id="foot-prebuild">
					<h4 class="menu-title text-white text-upper text-light">NZXT Prebuild</h4>
					<ul class="list-none">
						<li>
							<router-link :to="{ name: 'starter-series' }">Starter PC Series</router-link>
						</li>
						<li>
							<router-link to="/streaming-pc">Streaming PC</router-link>
						</li>
						<li>
							<router-link to="/h1-mini-pc">H1 Mini PC</router-link>
						</li>
						<li>
							<router-link to="/creator-pc">Creator PC</router-link>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="row m-a-0 p-y-md bg-black">
			<div class="container-fluid">
				<div class="footer-links p-a-0 clearfix">
					<div class="rights-content col-xs-12 col-md-4">
						<img
							src="/images/logos/logo-nzxt.png"
							alt=""
							class="pull-left nzxt-logo"
							height="32"
						>
						<p class="pull-left">{{ currentYear }}. All Rights Reserved.</p>
					</div>
					<div class="tos-content foot-tos text-center col-xs-12 col-md-4">
						<a href="https://www.nzxt.com/privacy-policy" target="_blank">Privacy Policy</a>
						<a href="https://www.nzxt.com/terms-of-service" target="_blank">Terms of Service</a>
						<a href="/sitemap.xml" target="_blank">Sitemap</a>
					</div>
					<div class="social-content social-icons text-center col-xs-12 col-md-4">
						<router-link to="//www.facebook.com/nzxt" target="_blank">
							<i class="fa fa-facebook-square"/>
						</router-link>
						<router-link to="//twitter.com/intent/follow?screen_name=nzxt" target="_blank">
							<i class="fa fa-twitter"/>
						</router-link>
						<router-link to="//www.instagram.com/nzxt/" target="_blank">
							<i class="fa fa-instagram"/>
						</router-link>
						<router-link to="//youtube.com/nzxtus" target="_blank">
							<i class="fa fa-youtube"/>
						</router-link>
						<router-link to="//www.twitch.tv/nzxt" target="_blank">
							<i class="fa fa-twitch"/>
						</router-link>
						<router-link to="//www.reddit.com/r/nzxt" target="_blank">
							<i class="fa fa-reddit"/>
						</router-link>
						<router-link to="//steamcommunity.com/groups/nzxtgaming" target="_blank">
							<i class="fa fa-steam"/>
						</router-link>
					</div>
				</div>
			</div>
		</div>
	</footer>
	<!-- /.footer -->
</template>


<script>
import { isMobile } from "@u/helpers";
import { gtmTrack } from "@/util/gtm";

export default {
	name: "Footer",
	data() {
		return {
			isProduction: CONFIG.PRODUCTION,
			currentYear: CONFIG.CURRENT_YEAR,
			excludesRoutes: ["step1", "step2", "step3", "step5"],
			hideOnIpadConfigurator: false
		};
	},
	watch:{
		"$route": {
			handler: "hideConfigurator"
		}
	},
	created() {
		this.hideConfigurator();
	},
	methods: {
		hideConfigurator() {
			if (isMobile(true)) {
				this.hideOnIpadConfigurator = this.excludesRoutes.includes(this.$route.name);
			}
		},
		openLogIn() {
			if (!Cookies.get("cookies_id")) {
				this.$modal.show("login-modal");
				this.$router.push({ name: "UserAccount", query: {
					redirect: "/user/account",
					currentTab: "account-info"
				} });
			} else {
				this.$router.push({
					name: "UserAccount",
					query: {
						currentTab: "account-info"
					}
				});
			}
		},
		openSignIn() {
			if (!Cookies.get("cookies_id")) {
				this.$modal.show("sign-up-modal");
			} else {
				this.$router.push({
					name: "UserAccount",
					query: {
						currentTab: "account-info"
					}
				});
			}
		},
		trackSupportViews(event) {
			const url = event.target.href;
			gtmTrack.visitSupportPage();
			if (url) {
				window.location.href = url;
			}
		}
	}
};
</script>

<style lang="scss">
.nzxt-logo {
    margin-top: 2px;
}
</style>
